// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {unsafelyParseMarkdown, Tag} from 'docs/util';

function mapItems(list, config) {
  return list.map((version) => [
    version[0],
    version[1].map((item) => {
      if (item.description) {
        const description = unsafelyParseMarkdown(item.description, config);
        return {
          ...item,
          description,
        };
      }
      return item;
    }),
  ]);
}

export const Changelog: MarkdocTagRegistration = {
  tag: 'changelog',
  component: 'Changelog',
  attributes: {
    list: {
      type: Array,
      required: true,
      description: 'Variable name of list to render from context',
    },
  },
  render(node, config) {
    const children = node.renderChildren(config);
    const attributes = node.renderAttributes(this.attributes, config);

    if (attributes.list) {
      return new Tag(
        this.tag,
        {
          ...attributes,
          list: mapItems(attributes.list, config),
        },
        children,
      );
    }

    return new Tag(this.tag, attributes, children);
  },
};
